// extracted by mini-css-extract-plugin
export var button = "button-demo-module--button--jJ4K3";
export var content = "button-demo-module--content--EXlwP";
export var title = "button-demo-module--title--qcFEr";
export var overlay = "button-demo-module--overlay--Dmg5y";
export var modal_content = "button-demo-module--modal_content--9UP32";
export var close_button = "button-demo-module--close_button--cU7hE";